export const translations = {
  de: {
    nav: {
      home: "Startseite", services: "Leistungen", machines: "Maschinenpark",
      gallery: "Werkstücke", about: "Über uns", contact: "Kontakt", inquiry: "Anfrage senden",
    },
    hero: {
      kicker: "CNC-Lohnfertigung & 3D-Druck — Gossensaß, Südtirol",
      line1: "Präzision, auf die",
      line2: "Sie sich verlassen",
      line3: "können.",
      sub: "CNC-Fertigung und 3D-Druck für Einzelteile, Prototypen und Serien.",
      cta1: "Fertigungsanfrage senden",
      cta2: "Leistungen ansehen",
      metrics: ["Einzelteile & Serien", "Fertigung nach Zeichnung oder 3D-Modell", "Direkter Draht zum Inhaber", "Standort in Südtirol"],
    },
    marquee: ["CNC-Drehen", "CNC-Fräsen", "3D-Druck", "Prototypen", "Kleinserien", "Lohnfertigung", "Einzelteile", "Südtirol"],
    advantages: {
      kicker: "Ihre Vorteile",
      title: "Warum R-Mechanik",
      items: [
        { title: "Präzise CNC-Bearbeitung", text: "Maßgenaue Fertigung nach Ihrer technischen Zeichnung oder Ihrem 3D-Modell." },
        { title: "Einzelteile und Serienfertigung", text: "Vom Einzelteil über Prototypen bis zu kleinen und mittleren Serien." },
        { title: "Flexible und persönliche Betreuung", text: "Sie sprechen direkt mit dem Verantwortlichen für Angebot und Produktion." },
        { title: "Kurze Entscheidungswege", text: "Inhabergeführt: schnelle Rückmeldungen und unkomplizierte Abstimmung." },
        { title: "Fertigung nach Zeichnung oder 3D-Modell", text: "PDF, STEP, DXF und weitere gängige Datenformate sind willkommen." },
        { title: "Standort in Südtirol", text: "Zentrale Lage an der Brennerachse – nah an Italien, Österreich und Deutschland." },
      ],
    },
    home: {
      aboutKicker: "Über uns",
      aboutTitle: "Inhabergeführte Fertigung aus Südtirol",
      aboutText: "R-Mechanik SRLS ist ein inhabergeführtes Fertigungsunternehmen aus Gossensaß. Bei uns sprechen Sie direkt mit der Person, die Ihr Angebot kalkuliert, Ihre Fertigung plant und Ihre Teile produziert. Das bedeutet: kurze Wege, klare Absprachen und eine zuverlässige Umsetzung.",
      aboutLink: "Mehr über uns",
      servicesKicker: "Leistungen",
      servicesTitle: "Was wir fertigen",
      services: [
        { key: "turning", title: "CNC-Drehen", text: "Drehteile aus Stahl, Edelstahl, Aluminium, Messing, Bronze und technischen Kunststoffen – mit angetriebenen Werkzeugen und C-Achse." },
        { key: "milling", title: "CNC-Fräsen", text: "Präzise Frästeile nach Zeichnung: Einzelteile, Vorrichtungen, Prototypen und Serien." },
        { key: "printing", title: "3D-Druck", text: "Funktionale Prototypen, Halterungen, Vorrichtungen und individuelle Bauteile aus verschiedenen Kunststoffen." },
      ],
      servicesLink: "Alle Leistungen im Detail",
      materialsKicker: "Werkstoffe",
      materialsTitle: "Typische Materialien",
      materialsNote: "Weitere Werkstoffe und Anforderungen nach Absprache.",
      processKicker: "Ablauf",
      processTitle: "So läuft Ihre Fertigungsanfrage",
      ctaTitle: "Bereit für Ihr Bauteil?",
      ctaText: "Senden Sie uns Ihre Zeichnung oder Ihr 3D-Modell – wir melden uns mit einem individuellen Angebot.",
      ctaButton: "Anfrage senden",
    },
    process: [
      { title: "Zeichnung oder 3D-Modell hochladen", text: "PDF, STEP, DXF oder Bild direkt im Formular." },
      { title: "Stückzahl und Anforderungen angeben", text: "Werkstoff, Toleranzen und Wunschtermin." },
      { title: "Technische Prüfung", text: "Wir prüfen Machbarkeit und Fertigungsaufwand." },
      { title: "Individuelles Angebot", text: "Sie erhalten ein transparentes, unverbindliches Angebot." },
      { title: "Fertigung nach Freigabe", text: "Die Produktion startet nach Ihrer Auftragsfreigabe." },
    ],
    servicesPage: {
      kicker: "Leistungen",
      title: "CNC-Fertigung und 3D-Druck",
      intro: "Vom einzelnen Drehteil bis zur Kleinserie: Wir fertigen nach Ihrer Zeichnung oder Ihrem 3D-Modell – präzise, flexibel und zuverlässig.",
      turning: {
        title: "CNC-Drehen",
        points: [
          "Fertigung von Einzelteilen, Prototypen und Serien",
          "Bearbeitung nach technischer Zeichnung oder 3D-Daten",
          "Drehteile aus Stahl, Edelstahl, Aluminium, Messing, Bronze und technischen Kunststoffen",
          "Bearbeitung mit angetriebenen Werkzeugen und C-Achse",
          "Bohrungen, Gewinde, Nuten und Fräsbearbeitungen direkt auf der Drehmaschine",
          "Geeignet für kleine bis mittlere Serien",
        ],
      },
      milling: {
        title: "CNC-Fräsen",
        points: [
          "Präzise Frästeile nach Zeichnung",
          "Einzelteile, Vorrichtungen, Prototypen und Serien",
          "Bohr-, Gewinde-, Taschen- und Konturbearbeitung",
          "Bearbeitung verschiedener Metalle und Kunststoffe",
        ],
        note: "Unser Fräsbereich wird laufend ausgebaut. Sprechen Sie uns an – wir prüfen jede Anfrage individuell.",
      },
      printing: {
        title: "3D-Druck",
        points: [
          "Funktionale Prototypen",
          "Halterungen, Abdeckungen und Vorrichtungen",
          "Individuelle Bauteile und Kleinserien",
          "Verschiedene Kunststoffe und flexible Materialien",
          "Fertigung anhand vorhandener 3D-Daten",
          "Unterstützung bei der Umsetzung einfacher Bauteile",
        ],
      },
      extras: {
        title: "Zusatzleistungen",
        points: [
          "Sägen und Materialvorbereitung",
          "Entgraten und Nachbearbeitung",
          "Maß- und Qualitätskontrolle",
          "Organisation externer Oberflächenbehandlungen nach Absprache",
          "Persönliche Beratung zur fertigungsgerechten Ausführung",
        ],
      },
      materialsTitle: "Werkstoffe",
      materials: ["Baustähle", "Vergütungsstähle", "Edelstahl", "Aluminium", "Messing", "Bronze & Aluminiumbronze", "Technische Kunststoffe"],
      industriesTitle: "Typische Einsatzbereiche",
      industries: ["Maschinenbau", "Anlagenbau", "Metallverarbeitung", "Instandhaltung & Reparatur", "Vorrichtungsbau", "Automatisierung", "Prototypenbau", "Ersatzteilfertigung"],
      materialsNote: "Weitere Werkstoffe und spezielle Anforderungen sind nach Absprache möglich.",
      ctaTitle: "Ihr Bauteil ist nicht dabei?",
      ctaText: "Senden Sie uns Ihre Zeichnung – wir prüfen jede Anfrage individuell und unverbindlich.",
    },
    machinesPage: {
      kicker: "Maschinenpark",
      title: "Unsere Fertigungstechnik",
      intro: "Übersicht unserer Maschinen. Der Maschinenpark wird laufend erweitert – als Nächstes folgt eine CNC-Fräsmaschine.",
      sectionCnc: "CNC-Maschinenpark",
      sectionPrint: "Prototypenbau mittels 3D-Druck",
      specsTitle: "Technische Daten",
      note: "Technische Angaben werden laufend ergänzt. Details zu Arbeitsbereichen erfragen Sie bitte direkt bei uns.",
    },
    galleryPage: {
      kicker: "Werkstücke",
      title: "Gefertigte Bauteile",
      intro: "Einblicke in unsere Fertigung: Drehteile, Frästeile und 3D-Druck-Projekte.",
      filters: { all: "Alle", drehen: "CNC-Drehen", fraesen: "CNC-Fräsen", druck: "3D-Druck" },
      placeholderBadge: "Platzhalterbild – wird ersetzt",
      close: "Schließen",
    },
    aboutPage: {
      kicker: "Über uns",
      title: "Persönlich. Präzise. Zuverlässig.",
      paragraphs: [
        "R-Mechanik SRLS ist ein inhabergeführtes Fertigungsunternehmen aus Gossensaß in Südtirol, gegründet und geführt von Julian Rizzi.",
        "Wir stehen für präzise Arbeit, flexible Lösungen und eine verlässliche Umsetzung. Bei uns gibt es keine anonymen Hotlines: Sie sprechen direkt mit dem Verantwortlichen für Angebot, Fertigungsplanung und Produktion.",
        "Dadurch entstehen kurze Entscheidungswege und eine direkte Betreuung – von der ersten Anfrage bis zum fertigen Bauteil. Ob Einzelteil, Prototyp oder Serie: Jede Anfrage wird individuell geprüft und ehrlich kalkuliert.",
        "Unser Standort an der Brennerachse macht uns zum idealen Partner für Unternehmen in Italien, Österreich und Deutschland.",
      ],
      values: [
        { title: "Präzision", text: "Maßhaltige Fertigung nach Zeichnung – ohne Kompromisse bei der Qualität." },
        { title: "Direktheit", text: "Ein Ansprechpartner für alles: Angebot, Planung und Produktion." },
        { title: "Flexibilität", text: "Einzelteile, Prototypen und Serien – auch kurzfristige Anfragen." },
        { title: "Verlässlichkeit", text: "Klare Absprachen und Zusagen, auf die Sie sich verlassen können." },
      ],
      ctaTitle: "Lernen wir uns kennen",
      ctaText: "Erzählen Sie uns von Ihrem Bauteil – wir melden uns persönlich bei Ihnen.",
    },
    contactPage: {
      kicker: "Kontakt",
      title: "Sprechen wir über Ihr Bauteil",
      intro: "Direkt, persönlich und unkompliziert – so erreichen Sie uns.",
      labels: { owner: "Inhaber", phone: "Telefon", email: "E-Mail", vat: "MwSt.-Nr.", pec: "PEC", sdi: "SDI-Code", hours: "Öffnungszeiten" },
      placeholder: "[Wird ergänzt]",
      hoursDays: "Montag – Freitag",
      hoursTimes: ["08:00–12:00 Uhr", "13:00–17:00 Uhr"],
      routeButton: "Route planen",
      mapTitle: "Anfahrt",
      mapText: "Aus Datenschutzgründen wird die Karte erst nach Ihrem Klick geladen. Dabei wird eine Verbindung zu Google Maps hergestellt.",
      mapLoad: "Karte laden (Google Maps)",
      formTitle: "Kurze Nachricht senden",
      formName: "Name *",
      formEmail: "E-Mail-Adresse *",
      formMessage: "Ihre Nachricht *",
      formSend: "Nachricht senden",
      formSending: "Wird gesendet…",
      formSuccess: "Vielen Dank! Ihre Nachricht wurde gesendet.",
      formError: "Senden fehlgeschlagen. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt per E-Mail.",
      inquiryCtaTitle: "Fertigungsanfrage statt kurzer Nachricht?",
      inquiryCtaText: "Laden Sie Zeichnungen hoch und fordern Sie direkt ein Angebot an.",
      inquiryCtaButton: "Zur Fertigungsanfrage",
    },
    inquiryPage: {
      kicker: "Fertigungsanfrage",
      title: "Angebot anfordern",
      intro: "Senden Sie uns Ihre Zeichnung oder Ihr 3D-Modell. Wir prüfen Ihre Anfrage technisch und melden uns mit einem individuellen Angebot.",
      hint: "Je vollständiger Ihre Angaben zu Werkstoff, Stückzahl, Toleranzen und gewünschtem Liefertermin sind, desto schneller können wir Ihre Anfrage bearbeiten.",
      processTitle: "So einfach geht's",
      form: {
        company: "Firma",
        name: "Vor- und Nachname *",
        email: "E-Mail-Adresse *",
        phone: "Telefonnummer",
        address: "Rechnungs- oder Firmenanschrift",
        service: "Gewünschte Leistung",
        serviceOptions: ["CNC-Drehen", "CNC-Fräsen", "3D-Druck", "Zusatzleistung / Sonstiges"],
        material: "Werkstoff",
        materialOptions: ["Baustahl", "Vergütungsstahl", "Edelstahl", "Aluminium", "Messing", "Bronze / Aluminiumbronze", "Technischer Kunststoff", "Sonstiger / nach Absprache"],
        quantity: "Stückzahl",
        delivery: "Gewünschter Liefertermin",
        message: "Nachricht / zusätzliche Anforderungen *",
        uploadTitle: "Dateien hochladen",
        uploadText: "PDF, STEP, STP, DXF, DWG, IGES, ZIP oder Bilder – max. 20 MB pro Datei, bis zu 8 Dateien.",
        uploadButton: "Dateien auswählen",
        uploadDrag: "Dateien hier ablegen oder",
        privacyBefore: "Ich habe die",
        privacyLink: "Datenschutzerklärung",
        privacyAfter: "gelesen und stimme der Verarbeitung meiner Daten zur Bearbeitung der Anfrage zu. *",
        submit: "Anfrage absenden",
        submitting: "Wird gesendet…",
        requiredNote: "* Pflichtfelder",
        fileTooLarge: "überschreitet 20 MB",
        fileBadType: "Dateiformat nicht erlaubt",
      },
      successTitle: "Vielen Dank für Ihre Anfrage!",
      successText: "Wir haben Ihre Angaben erhalten und eine Bestätigung an Ihre E-Mail-Adresse gesendet. Wir prüfen Ihre Anfrage technisch und melden uns mit einem individuellen Angebot.",
      newRequest: "Weitere Anfrage senden",
      error: "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt per E-Mail.",
    },
    legal: {
      draftBadge: "ENTWURF – Dieser Text ist ein Platzhalter und muss vor Veröffentlichung von einer fachkundigen Person geprüft werden.",
      imprint: {
        title: "Impressum",
        sections: [
          { heading: "Angaben gemäß gesetzlicher Informationspflicht", body: "R-Mechanik SRLS\nInhaber: Julian Rizzi\nPflerscherstraße 54\n39041 Gossensaß / Colle Isarco (BZ)\nSüdtirol – Italien" },
          { heading: "Kontakt", body: "Telefon: +39 345 580 7242\nE-Mail: info@r-mechanik.it\nPEC: r-mechanik@legalmail.it" },
          { heading: "Registereintrag", body: "Mehrwertsteuernummer: IT03286770213\nSDI-Code: USAL8PV\nHandelskammer Bozen / Camera di Commercio di Bolzano: [Wird ergänzt]" },
          { heading: "Haftung für Inhalte", body: "Die Inhalte dieser Website wurden mit Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit und Aktualität wird keine Gewähr übernommen. Alle Preise und Konditionen werden individuell pro Anfrage kalkuliert." },
        ],
      },
      privacy: {
        title: "Datenschutzerklärung",
        sections: [
          { heading: "Verantwortlicher", body: "R-Mechanik SRLS, Julian Rizzi, Pflerscherstraße 54, 39041 Gossensaß / Colle Isarco (BZ), Italien. E-Mail: info@r-mechanik.it" },
          { heading: "Verarbeitung bei Anfragen", body: "Bei Nutzung des Anfrage- oder Kontaktformulars verarbeiten wir die von Ihnen angegebenen Daten (Name, Kontaktdaten, Projektdaten, hochgeladene Dateien) ausschließlich zur Bearbeitung Ihrer Anfrage und zur Angebotserstellung (Art. 6 Abs. 1 lit. b DSGVO). Hochgeladene Dateien werden verschlüsselt übertragen und sicher gespeichert." },
          { heading: "Speicherdauer", body: "Anfragedaten werden nur so lange gespeichert, wie es für die Bearbeitung und gesetzliche Aufbewahrungspflichten erforderlich ist." },
          { heading: "Cookies", body: "Diese Website verwendet nur technisch notwendige Cookies. Analyse- oder Marketingdienste werden erst nach Ihrer ausdrücklichen Zustimmung geladen (siehe Cookie-Einstellungen)." },
          { heading: "Ihre Rechte", body: "Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch sowie das Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde (Garante per la protezione dei dati personali)." },
        ],
      },
      cookies: {
        title: "Cookie-Einstellungen",
        intro: "Diese Website verwendet nur technisch notwendige Cookies, die für den Betrieb erforderlich sind. Analyse- oder Marketingdienste werden erst nach Ihrer ausdrücklichen Zustimmung geladen.",
        openSettings: "Cookie-Einstellungen öffnen",
        currentState: "Ihr aktueller Status wird im Banner angezeigt und kann jederzeit geändert werden.",
      },
    },
    cookie: {
      text: "Wir verwenden nur technisch notwendige Cookies. Analyse- oder Marketingdienste werden erst nach Ihrer ausdrücklichen Zustimmung geladen.",
      acceptAll: "Alle akzeptieren",
      necessaryOnly: "Nur notwendige",
      settings: "Einstellungen",
      save: "Auswahl speichern",
      title: "Cookie-Einstellungen",
      necessary: "Notwendig",
      necessaryDesc: "Erforderlich für den Betrieb der Website – immer aktiv.",
      analytics: "Analyse",
      analyticsDesc: "Anonyme Nutzungsstatistik (aktuell nicht im Einsatz).",
      marketing: "Marketing",
      marketingDesc: "Externe Inhalte wie Karten (werden erst nach Klick geladen).",
    },
    footer: {
      description: "Inhabergeführte CNC-Lohnfertigung und 3D-Druck aus Gossensaß, Südtirol. Einzelteile, Prototypen und Serien – präzise und zuverlässig.",
      quickNav: "Navigation",
      servicesTitle: "Leistungen",
      contactTitle: "Kontakt",
      legalTitle: "Rechtliches",
      imprint: "Impressum",
      privacy: "Datenschutz",
      cookies: "Cookie-Einstellungen",
      rights: "Alle Rechte vorbehalten.",
      services: ["CNC-Drehen", "CNC-Fräsen", "3D-Druck", "Zusatzleistungen"],
    },
    seo: {
      home: { title: "R-Mechanik SRLS – CNC-Fertigung & 3D-Druck Südtirol", desc: "CNC-Lohnfertigung und 3D-Druck in Gossensaß, Südtirol. Einzelteile, Prototypen und Serien nach Zeichnung. Jetzt Angebot anfordern." },
      services: { title: "Leistungen – CNC Drehen, Fräsen & 3D-Druck | R-Mechanik Südtirol", desc: "CNC-Drehen, CNC-Fräsen und 3D-Druck in Südtirol: Einzelteile, Prototypen und Serien aus Stahl, Edelstahl, Aluminium und Kunststoff." },
      machines: { title: "Maschinenpark | R-Mechanik SRLS Gossensaß", desc: "Unser Maschinenpark: DN Solutions Puma 3100M CNC-Drehmaschine mit angetriebenen Werkzeugen und C-Achse." },
      gallery: { title: "Werkstücke & Referenzen | R-Mechanik Südtirol", desc: "Gefertigte Drehteile, Frästeile und 3D-Druck-Projekte von R-Mechanik aus Gossensaß, Südtirol." },
      about: { title: "Über uns – Inhabergeführte CNC-Fertigung | R-Mechanik", desc: "R-Mechanik SRLS: inhabergeführtes Fertigungsunternehmen aus Südtirol. Persönlich, präzise, zuverlässig." },
      contact: { title: "Kontakt & Anfahrt | R-Mechanik SRLS Gossensaß", desc: "Kontakt zu R-Mechanik SRLS in Gossensaß/Colle Isarco, Südtirol. Telefon, E-Mail und Anfahrt." },
      inquiry: { title: "Fertigungsanfrage senden | R-Mechanik Südtirol", desc: "Zeichnung hochladen und Angebot anfordern: CNC-Lohnfertigung und 3D-Druck aus Südtirol." },
      imprint: { title: "Impressum | R-Mechanik SRLS", desc: "Impressum der R-Mechanik SRLS, Gossensaß, Südtirol." },
      privacy: { title: "Datenschutzerklärung | R-Mechanik SRLS", desc: "Datenschutzerklärung der R-Mechanik SRLS – Informationen zur Datenverarbeitung." },
      cookies: { title: "Cookie-Einstellungen | R-Mechanik SRLS", desc: "Cookie-Einstellungen der Website von R-Mechanik SRLS." },
    },
  },
  it: {
    nav: {
      home: "Home", services: "Servizi", machines: "Parco macchine",
      gallery: "Pezzi lavorati", about: "Chi siamo", contact: "Contatti", inquiry: "Invia richiesta",
    },
    hero: {
      kicker: "Lavorazioni CNC & stampa 3D — Colle Isarco, Alto Adige",
      line1: "Precisione",
      line2: "su cui potete",
      line3: "contare.",
      sub: "Lavorazioni CNC e stampa 3D per pezzi singoli, prototipi e serie.",
      cta1: "Invia richiesta di produzione",
      cta2: "Scopri i servizi",
      metrics: ["Pezzi singoli & serie", "Produzione da disegno o modello 3D", "Contatto diretto con il titolare", "Sede in Alto Adige"],
    },
    marquee: ["Tornitura CNC", "Fresatura CNC", "Stampa 3D", "Prototipi", "Piccole serie", "Conto terzi", "Pezzi singoli", "Alto Adige"],
    advantages: {
      kicker: "I vostri vantaggi",
      title: "Perché R-Mechanik",
      items: [
        { title: "Lavorazione CNC di precisione", text: "Produzione a misura secondo il vostro disegno tecnico o modello 3D." },
        { title: "Pezzi singoli e serie", text: "Dal pezzo singolo ai prototipi fino a piccole e medie serie." },
        { title: "Assistenza flessibile e personale", text: "Parlate direttamente con il responsabile di offerta e produzione." },
        { title: "Iter decisionali brevi", text: "Azienda a conduzione diretta: risposte rapide e accordi semplici." },
        { title: "Produzione da disegno o modello 3D", text: "PDF, STEP, DXF e altri formati comuni sono benvenuti." },
        { title: "Sede in Alto Adige", text: "Posizione centrale sull'asse del Brennero – vicino a Italia, Austria e Germania." },
      ],
    },
    home: {
      aboutKicker: "Chi siamo",
      aboutTitle: "Produzione a conduzione diretta dall'Alto Adige",
      aboutText: "R-Mechanik SRLS è un'azienda di produzione a conduzione diretta di Colle Isarco. Da noi parlate direttamente con la persona che calcola la vostra offerta, pianifica la produzione e realizza i vostri pezzi. Questo significa: percorsi brevi, accordi chiari e un'esecuzione affidabile.",
      aboutLink: "Scopri di più su di noi",
      servicesKicker: "Servizi",
      servicesTitle: "Cosa produciamo",
      services: [
        { key: "turning", title: "Tornitura CNC", text: "Pezzi torniti in acciaio, acciaio inox, alluminio, ottone, bronzo e tecnopolimeri – con utensili motorizzati e asse C." },
        { key: "milling", title: "Fresatura CNC", text: "Pezzi fresati di precisione a disegno: pezzi singoli, attrezzature, prototipi e serie." },
        { key: "printing", title: "Stampa 3D", text: "Prototipi funzionali, supporti, attrezzature e componenti individuali in diversi materiali plastici." },
      ],
      servicesLink: "Tutti i servizi in dettaglio",
      materialsKicker: "Materiali",
      materialsTitle: "Materiali tipici",
      materialsNote: "Altri materiali e requisiti su richiesta.",
      processKicker: "Procedura",
      processTitle: "Come funziona la vostra richiesta",
      ctaTitle: "Pronti per il vostro componente?",
      ctaText: "Inviateci il vostro disegno o modello 3D – vi risponderemo con un'offerta individuale.",
      ctaButton: "Invia richiesta",
    },
    process: [
      { title: "Caricare disegno o modello 3D", text: "PDF, STEP, DXF o immagine direttamente nel modulo." },
      { title: "Indicare quantità e requisiti", text: "Materiale, tolleranze e data di consegna desiderata." },
      { title: "Verifica tecnica", text: "Verifichiamo fattibilità e impegno produttivo." },
      { title: "Offerta individuale", text: "Riceverete un'offerta trasparente e non vincolante." },
      { title: "Produzione dopo approvazione", text: "La produzione inizia dopo la vostra conferma d'ordine." },
    ],
    servicesPage: {
      kicker: "Servizi",
      title: "Lavorazioni CNC e stampa 3D",
      intro: "Dal singolo pezzo tornito alla piccola serie: produciamo secondo il vostro disegno o modello 3D – con precisione, flessibilità e affidabilità.",
      turning: {
        title: "Tornitura CNC",
        points: [
          "Produzione di pezzi singoli, prototipi e serie",
          "Lavorazione secondo disegno tecnico o dati 3D",
          "Pezzi torniti in acciaio, acciaio inox, alluminio, ottone, bronzo e tecnopolimeri",
          "Lavorazione con utensili motorizzati e asse C",
          "Forature, filettature, scanalature e fresature direttamente sul tornio",
          "Adatto per piccole e medie serie",
        ],
      },
      milling: {
        title: "Fresatura CNC",
        points: [
          "Pezzi fresati di precisione a disegno",
          "Pezzi singoli, attrezzature, prototipi e serie",
          "Forature, filettature, tasche e contorni",
          "Lavorazione di diversi metalli e materie plastiche",
        ],
        note: "Il nostro reparto di fresatura è in continua espansione. Contattateci – valutiamo ogni richiesta individualmente.",
      },
      printing: {
        title: "Stampa 3D",
        points: [
          "Prototipi funzionali",
          "Supporti, coperture e attrezzature",
          "Componenti individuali e piccole serie",
          "Diverse materie plastiche e materiali flessibili",
          "Produzione sulla base di dati 3D esistenti",
          "Supporto nella realizzazione di componenti semplici",
        ],
      },
      extras: {
        title: "Servizi aggiuntivi",
        points: [
          "Taglio e preparazione del materiale",
          "Sbavatura e finitura",
          "Controllo dimensionale e qualità",
          "Organizzazione di trattamenti superficiali esterni su accordo",
          "Consulenza personale per un'esecuzione orientata alla produzione",
        ],
      },
      materialsTitle: "Materiali",
      materials: ["Acciai da costruzione", "Acciai da bonifica", "Acciaio inox", "Alluminio", "Ottone", "Bronzo e bronzo d'alluminio", "Tecnopolimeri"],
      industriesTitle: "Settori tipici di applicazione",
      industries: ["Costruzione di macchine", "Impiantistica", "Lavorazione dei metalli", "Manutenzione e riparazione", "Costruzione di attrezzature", "Automazione", "Prototipazione", "Produzione di ricambi"],
      materialsNote: "Altri materiali e requisiti speciali sono possibili su accordo.",
      ctaTitle: "Il vostro componente non è in elenco?",
      ctaText: "Inviateci il vostro disegno – valutiamo ogni richiesta individualmente e senza impegno.",
    },
    machinesPage: {
      kicker: "Parco macchine",
      title: "La nostra tecnologia di produzione",
      intro: "Panoramica delle nostre macchine. Il parco macchine è in continua espansione – la prossima sarà una fresatrice CNC.",
      sectionCnc: "Parco macchine CNC",
      sectionPrint: "Prototipazione tramite stampa 3D",
      specsTitle: "Dati tecnici",
      note: "I dati tecnici vengono integrati regolarmente. Per dettagli sulle aree di lavoro contattateci direttamente.",
    },
    galleryPage: {
      kicker: "Pezzi lavorati",
      title: "Componenti prodotti",
      intro: "Uno sguardo alla nostra produzione: pezzi torniti, fresati e progetti di stampa 3D.",
      filters: { all: "Tutti", drehen: "Tornitura CNC", fraesen: "Fresatura CNC", druck: "Stampa 3D" },
      placeholderBadge: "Immagine segnaposto – da sostituire",
      close: "Chiudi",
    },
    aboutPage: {
      kicker: "Chi siamo",
      title: "Personale. Preciso. Affidabile.",
      paragraphs: [
        "R-Mechanik SRLS è un'azienda di produzione a conduzione diretta di Colle Isarco in Alto Adige, fondata e guidata da Julian Rizzi.",
        "Siamo sinonimo di lavoro preciso, soluzioni flessibili ed esecuzione affidabile. Da noi non ci sono hotline anonime: parlate direttamente con il responsabile di offerta, pianificazione e produzione.",
        "Ne derivano iter decisionali brevi e un'assistenza diretta – dalla prima richiesta al componente finito. Che si tratti di pezzo singolo, prototipo o serie: ogni richiesta viene valutata individualmente e calcolata onestamente.",
        "La nostra sede sull'asse del Brennero ci rende il partner ideale per aziende in Italia, Austria e Germania.",
      ],
      values: [
        { title: "Precisione", text: "Produzione a misura secondo disegno – senza compromessi sulla qualità." },
        { title: "Direttezza", text: "Un unico interlocutore per tutto: offerta, pianificazione e produzione." },
        { title: "Flessibilità", text: "Pezzi singoli, prototipi e serie – anche richieste a breve termine." },
        { title: "Affidabilità", text: "Accordi e promesse chiari su cui potete contare." },
      ],
      ctaTitle: "Conosciamoci",
      ctaText: "Raccontateci il vostro componente – vi risponderemo personalmente.",
    },
    contactPage: {
      kicker: "Contatti",
      title: "Parliamo del vostro componente",
      intro: "Diretto, personale e senza complicazioni – ecco come raggiungerci.",
      labels: { owner: "Titolare", phone: "Telefono", email: "E-Mail", vat: "P.IVA", pec: "PEC", sdi: "Codice SDI", hours: "Orari di apertura" },
      placeholder: "[Da integrare]",
      hoursDays: "Lunedì – Venerdì",
      hoursTimes: ["08:00–12:00", "13:00–17:00"],
      routeButton: "Calcola percorso",
      mapTitle: "Come raggiungerci",
      mapText: "Per motivi di protezione dei dati, la mappa viene caricata solo dopo il vostro clic. Verrà stabilita una connessione a Google Maps.",
      mapLoad: "Carica mappa (Google Maps)",
      formTitle: "Invia un messaggio",
      formName: "Nome *",
      formEmail: "Indirizzo e-mail *",
      formMessage: "Il vostro messaggio *",
      formSend: "Invia messaggio",
      formSending: "Invio in corso…",
      formSuccess: "Grazie! Il vostro messaggio è stato inviato.",
      formError: "Invio non riuscito. Riprovate o scriveteci direttamente via e-mail.",
      inquiryCtaTitle: "Richiesta di produzione invece di un messaggio?",
      inquiryCtaText: "Caricate i disegni e richiedete direttamente un'offerta.",
      inquiryCtaButton: "Alla richiesta di produzione",
    },
    inquiryPage: {
      kicker: "Richiesta di produzione",
      title: "Richiedi un'offerta",
      intro: "Inviateci il vostro disegno o modello 3D. Verificheremo tecnicamente la vostra richiesta e vi risponderemo con un'offerta individuale.",
      hint: "Più complete sono le vostre indicazioni su materiale, quantità, tolleranze e data di consegna desiderata, più velocemente potremo elaborare la vostra richiesta.",
      processTitle: "È semplicissimo",
      form: {
        company: "Azienda",
        name: "Nome e cognome *",
        email: "Indirizzo e-mail *",
        phone: "Numero di telefono",
        address: "Indirizzo di fatturazione o aziendale",
        service: "Servizio desiderato",
        serviceOptions: ["Tornitura CNC", "Fresatura CNC", "Stampa 3D", "Servizio aggiuntivo / Altro"],
        material: "Materiale",
        materialOptions: ["Acciaio da costruzione", "Acciaio da bonifica", "Acciaio inox", "Alluminio", "Ottone", "Bronzo / bronzo d'alluminio", "Tecnopolimero", "Altro / su accordo"],
        quantity: "Quantità",
        delivery: "Data di consegna desiderata",
        message: "Messaggio / requisiti aggiuntivi *",
        uploadTitle: "Carica file",
        uploadText: "PDF, STEP, STP, DXF, DWG, IGES, ZIP o immagini – max. 20 MB per file, fino a 8 file.",
        uploadButton: "Seleziona file",
        uploadDrag: "Trascina i file qui oppure",
        privacyBefore: "Ho letto l'",
        privacyLink: "informativa sulla privacy",
        privacyAfter: "e acconsento al trattamento dei miei dati per l'elaborazione della richiesta. *",
        submit: "Invia richiesta",
        submitting: "Invio in corso…",
        requiredNote: "* Campi obbligatori",
        fileTooLarge: "supera i 20 MB",
        fileBadType: "Formato file non consentito",
      },
      successTitle: "Grazie per la vostra richiesta!",
      successText: "Abbiamo ricevuto i vostri dati e inviato una conferma al vostro indirizzo e-mail. Verificheremo tecnicamente la richiesta e vi risponderemo con un'offerta individuale.",
      newRequest: "Invia un'altra richiesta",
      error: "Si è verificato un errore durante l'invio. Riprovate o contattateci direttamente via e-mail.",
    },
    legal: {
      draftBadge: "BOZZA – Questo testo è un segnaposto e deve essere verificato da una persona qualificata prima della pubblicazione.",
      imprint: {
        title: "Note legali",
        sections: [
          { heading: "Informazioni ai sensi dell'obbligo legale di informazione", body: "R-Mechanik SRLS\nTitolare: Julian Rizzi\nVia Fleres 54 / Pflerscherstraße 54\n39041 Colle Isarco / Gossensaß (BZ)\nAlto Adige – Italia" },
          { heading: "Contatti", body: "Telefono: +39 345 580 7242\nE-Mail: info@r-mechanik.it\nPEC: r-mechanik@legalmail.it" },
          { heading: "Iscrizione al registro", body: "Partita IVA: IT03286770213\nCodice SDI: USAL8PV\nCamera di Commercio di Bolzano: [Da integrare]" },
          { heading: "Responsabilità per i contenuti", body: "I contenuti di questo sito sono stati creati con cura. Non si assume alcuna garanzia per correttezza, completezza e attualità. Tutti i prezzi e le condizioni vengono calcolati individualmente per ogni richiesta." },
        ],
      },
      privacy: {
        title: "Informativa sulla privacy",
        sections: [
          { heading: "Titolare del trattamento", body: "R-Mechanik SRLS, Julian Rizzi, Via Fleres 54 / Pflerscherstraße 54, 39041 Colle Isarco (BZ), Italia. E-Mail: info@r-mechanik.it" },
          { heading: "Trattamento delle richieste", body: "Utilizzando il modulo di richiesta o contatto, trattiamo i dati da voi forniti (nome, dati di contatto, dati di progetto, file caricati) esclusivamente per elaborare la vostra richiesta e preparare un'offerta (art. 6 par. 1 lett. b GDPR). I file caricati vengono trasmessi in modo crittografato e archiviati in sicurezza." },
          { heading: "Durata di conservazione", body: "I dati delle richieste vengono conservati solo per il tempo necessario all'elaborazione e agli obblighi di conservazione legali." },
          { heading: "Cookie", body: "Questo sito utilizza solo cookie tecnicamente necessari. Servizi di analisi o marketing vengono caricati solo dopo il vostro consenso esplicito (vedi impostazioni cookie)." },
          { heading: "I vostri diritti", body: "Avete diritto di accesso, rettifica, cancellazione, limitazione del trattamento, portabilità dei dati e opposizione, nonché il diritto di reclamo all'autorità di controllo competente (Garante per la protezione dei dati personali)." },
        ],
      },
      cookies: {
        title: "Impostazioni cookie",
        intro: "Questo sito utilizza solo cookie tecnicamente necessari per il suo funzionamento. Servizi di analisi o marketing vengono caricati solo dopo il vostro consenso esplicito.",
        openSettings: "Apri impostazioni cookie",
        currentState: "Il vostro stato attuale viene visualizzato nel banner e può essere modificato in qualsiasi momento.",
      },
    },
    cookie: {
      text: "Utilizziamo solo cookie tecnicamente necessari. Servizi di analisi o marketing vengono caricati solo dopo il vostro consenso esplicito.",
      acceptAll: "Accetta tutto",
      necessaryOnly: "Solo necessari",
      settings: "Impostazioni",
      save: "Salva selezione",
      title: "Impostazioni cookie",
      necessary: "Necessari",
      necessaryDesc: "Necessari per il funzionamento del sito – sempre attivi.",
      analytics: "Analisi",
      analyticsDesc: "Statistiche di utilizzo anonime (attualmente non in uso).",
      marketing: "Marketing",
      marketingDesc: "Contenuti esterni come le mappe (caricati solo dopo clic).",
    },
    footer: {
      description: "Lavorazioni CNC conto terzi e stampa 3D a conduzione diretta da Colle Isarco, Alto Adige. Pezzi singoli, prototipi e serie – precisi e affidabili.",
      quickNav: "Navigazione",
      servicesTitle: "Servizi",
      contactTitle: "Contatti",
      legalTitle: "Note legali",
      imprint: "Note legali",
      privacy: "Privacy",
      cookies: "Impostazioni cookie",
      rights: "Tutti i diritti riservati.",
      services: ["Tornitura CNC", "Fresatura CNC", "Stampa 3D", "Servizi aggiuntivi"],
    },
    seo: {
      home: { title: "R-Mechanik SRLS – Lavorazioni CNC & stampa 3D Alto Adige", desc: "Lavorazioni meccaniche conto terzi e stampa 3D a Colle Isarco, Alto Adige. Pezzi singoli, prototipi e serie a disegno. Richiedete un'offerta." },
      services: { title: "Servizi – Tornitura CNC, fresatura & stampa 3D | R-Mechanik", desc: "Tornitura CNC, fresatura CNC e stampa 3D in Alto Adige: pezzi singoli, prototipi e serie in acciaio, inox, alluminio e plastica." },
      machines: { title: "Parco macchine | R-Mechanik SRLS Colle Isarco", desc: "Il nostro parco macchine: tornio CNC DN Solutions Puma 3100M con utensili motorizzati e asse C." },
      gallery: { title: "Pezzi lavorati & referenze | R-Mechanik Alto Adige", desc: "Pezzi torniti, fresati e progetti di stampa 3D di R-Mechanik da Colle Isarco, Alto Adige." },
      about: { title: "Chi siamo – Produzione CNC a conduzione diretta | R-Mechanik", desc: "R-Mechanik SRLS: azienda di produzione a conduzione diretta dell'Alto Adige. Personale, precisa, affidabile." },
      contact: { title: "Contatti & come raggiungerci | R-Mechanik SRLS", desc: "Contatti di R-Mechanik SRLS a Colle Isarco/Gossensaß, Alto Adige. Telefono, e-mail e indicazioni stradali." },
      inquiry: { title: "Invia richiesta di produzione | R-Mechanik Alto Adige", desc: "Caricate il disegno e richiedete un'offerta: lavorazioni CNC conto terzi e stampa 3D dall'Alto Adige." },
      imprint: { title: "Note legali | R-Mechanik SRLS", desc: "Note legali di R-Mechanik SRLS, Colle Isarco, Alto Adige." },
      privacy: { title: "Informativa sulla privacy | R-Mechanik SRLS", desc: "Informativa sulla privacy di R-Mechanik SRLS – informazioni sul trattamento dei dati." },
      cookies: { title: "Impostazioni cookie | R-Mechanik SRLS", desc: "Impostazioni cookie del sito web di R-Mechanik SRLS." },
    },
  },
};
